<template>
  <div class="case-container">
    <div class="case-top">
      <carousel :list="bannerList"/>
    </div>
    <div class="case-main">
      <div class="case-nav">
        <div class="case-nav-list">
          <router-link to="/" class="case-nav-first">首页</router-link>
          <span class="case-nav-mark">>></span>
          <span class="case-nav-current">客户案例详情</span>
        </div>
      </div>
      <div class="case-details">
        <div class="case-details-text" v-html="caseDetails.caseDetail"></div>
        <div class="case-recommend-main">
          <div class="case-recommend-title">推荐案例</div>
          <div class="case-recommend-list">
            <recommendItem :recommendItem="item" v-for="item in customerCaseList" :key="item.id" @click="queryCaseDetails(item.id)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import carousel from '@/components/carousel/index.vue'
import {ref} from "vue";
import {getBannerList, getCustomerCaseList} from "@/api/apiHome";
import {getCaseDetails} from "@/api/apiUserCase";
import {useRoute} from 'vue-router'
import recommendItem from './components/recommendItem.vue'

const route = useRoute()
const caseDetails = ref({})
const bannerList = ref([])
const customerCaseList = ref([])
const queryBannerList = async () => {
  const {code, data} = await getBannerList(10)
  if (code === 200) {
    bannerList.value = data
  }
}
const queryCaseDetails = async (id) => {
  if (!route.query.id&&!id) return
  const newId=id ? id :route.query.id;
  const {code, data} = await getCaseDetails(newId)
  if (code === 200) {
    caseDetails.value = data
    await queryConsultationList(newId)
  }
}
const queryConsultationList = async (id) => {
  const {code, data} = await getCustomerCaseList(id);
  if (code === 200) {
    customerCaseList.value = data;
  }
}
queryBannerList()
queryCaseDetails("")
</script>

<style scoped lang="scss">
.case-top {
  width: 100%;
  height: 540px;
  overflow: hidden;
}

.case-nav {
  width: 100%;
  height: 36px;
}

.case-nav-list {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.case-nav-first {
  margin: 0 10px;
  font-size: 16px;
  color: #242424;
}

.case-nav-mark {
  margin: 0 14px;
  font-size: 16px;
  font-weight: bold;
  color: #242424;
}

.case-nav-current {
  font-size: 16px;
  color: #0048A9;
}
.case-main{
  width: 1200px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
}
.case-details {
  display: flex;
  margin-bottom: 40px;
}

.case-details-text {
  padding: 20px;
  box-shadow: 0 0 12px rgba(0, 0, 0, .12);
  :deep(td) {
    border-width: 0 !important;
    border-style: none !important;
  }
  :deep(img) {
    width: 100%;
  }
}
.case-recommend-main {
  width: 311px;
  box-sizing: border-box;
}
.case-recommend-title {
  font-weight: bold;
  font-size: 20px;
  color: #242424;
  background: #F4F8FF;
  padding: 20px;
}

.case-recommend-list {
  background: #F4F8FF;
  padding:0 20px 1px 20px;
}
</style>
